export const buildReportFieldDraggableId = (
  droppableId: string,
  fieldId: string,
): string => `${droppableId}-${fieldId}`;
